<template>
  <van-form
    class="question-container"
    ref="form"
    :show-error="false"
    :scroll-to-error="true"
    :submit-on-enter="false"
    @submit.native.prevent
  >
    <template v-for="(field, index) in formLine">
      <van-cell
        class="question"
        title-class="title"
        label-class="label"
        :key="index"
      >
        <template #title>
          <span class="question-title" v-html="field.title"></span>
        </template>
        <template #icon>
          {{ `${index + 1}. ` }}
        </template>
        <template #label>
          <uploaderFile
            v-if="field.elType === 'file'"
            class="upload-file"
            ref="upload"
            :field="field"
            :data="data"
          >
          </uploaderFile>
          <vanCustomField
            v-else
            :data="data"
            :field="field"
          >
          </vanCustomField>
        </template>
      </van-cell>
    </template>
  </van-form>
</template>

<script>
import _ from 'lodash'
import vanCustomField from './vanCustomField.vue'
import uploaderFile from './uploadFile.vue'
export default {
  components: {
    vanCustomField,
    uploaderFile
  },
  props: {
    formLine: {
      required: true
    },
    data: {
      required: true
    }
  },
  methods: {
    async submit () {
      try {
        await this.$refs.form.validate()
        let uploadValidate = true
        _.forEach(this.$refs.upload, async (upload) => {
          const result = upload.validate()
          if (!result) {
            uploadValidate = false
          }
        })
        return uploadValidate && true
      } catch (e) {
        this.errorInfo = e
        this.$nextTick(() => {
          const el = this.$el.querySelector('.van-field__error-message')
          if (el) {
            el.scrollIntoView({ block: 'center', behavior: 'smooth' })
          }
        })
        return false
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.question-container.van-form {
  .van-cell {
    line-height: 20px;
    font-size: 14px;
  }

  .question {
    padding: 20px 0;
    border-bottom: 1px solid #DCDFE6;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .label {
    margin-top: 8px;

    .upload-file {
      margin-top: 12px;
    }
  }

  .title {
    margin-left: 2px;

    .question-title {
      white-space: break-spaces;
      word-break: break-word;

      &::after {
        position: relative;
        left: 2px;
        color: #ea7f7f;
        font-size: 14px;
        content: '*';
      }
    }

  }

  ::v-deep {
    .common-field {
      border-bottom: none;

      .van-field__body {
        padding: 5px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        min-height: initial;
      }
    }
  }
}
</style>
